<template>
  <v-app>
    <template>
      <main-toolbar />
      <main-drawer />
      <v-content style="background: #f5f5f5">
        <v-container fluid class="pa-3">
          <router-view />
        </v-container>
      </v-content>
    </template>
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
    >
      <div class="d-flex align-center justify-space-between" style="width: 100%">
        <span v-html="snackbar.text"></span>
        <v-icon dark @click="hideSnackbar" class="ml-2" style="cursor: pointer">
          close
        </v-icon>
      </div>
    </v-snackbar>

    <v-overlay
      :value="overlay"
      class="align-center justify-center"
    >
      <v-progress-circular
        color="primary"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import MainToolbar from '@/shared/MainToolbar';
import MainDrawer from '@/shared/MainDrawer';

export default {
  name: 'Layout',
  components: {
    MainToolbar,
    MainDrawer,
  },
  computed: {
    ...mapState('app', ['snackbar', 'overlay']),
  },
  methods: {
    ...mapActions('app', ['hideSnackbar']),
  },
};
</script>
